<template>
    <div>
        <div class="store_income">
            <div class="left_list_title">
                <span>中山路街区营收情况</span>
            </div>
            <div class="echart" id="right_2" :style="myChartStyle"></div>
        </div>
    </div>
</template>
<script>
import Swiper from "@/assets/js/swiper.min.js";
import * as echarts from "echarts";

export default {
    data() {
        return {
            charbar:null,
            x_data1: [],
            y_data1: [],
            myChartStyle: { width: "1310px", height: "350px" }, //图表样式
        };
    },
    components: {},
    props: {
        mall_revenue_state: {
            typeof: Array,
            default: () => [],
        },
    },
    mounted() {
        this.revenueInfo();
    },
    watch:{
        mall_revenue_state:{
            deep: true,
            handler: function (newV, oldV) {
                this.revenueInfo();
            },
        }
    },
    created() { },
    beforeDestroy() {
        if (this.charbar) {
            this.charbar.clear()
        }
    },
    methods: {
        revenueInfo() {
            if(this.mall_revenue_state){
                this.x_data1=[];
                this.y_data1=[];
                for (let index = 0; index < this.mall_revenue_state.length; index++) {
                    const element = this.mall_revenue_state[index];
                    this.x_data1.push(element.mouth);
                    this.y_data1.push(element.value)
                }
            }

            let option = {
                grid: {
                    top: "30%",
                    bottom: "10%",
                    right: "3%",
                    left: "5%",
                },
                xAxis: {
                    data: this.x_data1,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        fontSize: 16,
                        margin: 10,
                        color: "rgba(255,255,255,.7)",
                    },
                    interval: 0,
                },
                yAxis: {
                    splitNumber: 7,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "rgba(255,255,255,.16)",
                            // type: "dashed",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        textStyle: {
                            show: true,
                            color: "rgba(255,255,255,.7)",
                            fontSize: 15,
                        },
                    },
                },
                title: [
                    {
                        text: "单位：万元",
                        x: "1%",
                        y: "15%",
                        textStyle: {
                            fontSize: 13,
                            color: "#90BDE0",
                        },
                    },
                ],
                series: [
                    {
                        name: "柱顶部",
                        type: "pictorialBar",
                        symbolSize: [20, 10],
                        symbolOffset: [0, -6],
                        itemStyle: {
                            color: function (params) {
                                return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: "rgba(33,243,255,0.9)",
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(33,243,255,0.9)",
                                    },
                                ]);
                            },
                            opacity: 0.8,
                        },
                        label: {
                            show: true,
                            position: "top",
                            fontSize: 16,
                            color: "rgba(33,243,255,1)",
                        },
                        symbolPosition: "end",
                        data: this.y_data1,
                    },
                    {
                        name: "柱底部",
                        type: "pictorialBar",
                        symbolSize: [20, 8],
                        symbolOffset: [0, 5],
                        itemStyle: {
                            color: "rgba(31,97,234,0.5)",
                        },
                        data: this.y_data1,
                    },
                    {
                        name: "商场营收情况",
                        type: "bar",
                        itemStyle: {
                            margin: 50,

                            color: function (params) {
                                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: "rgba(0,183,255,1)",
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(34,68,172,0.35)",
                                    },
                                ]);
                            },
                            opacity: 0.9,
                        },
                        barWidth: 20,
                        data: this.y_data1,
                    },
                ],
            };
            var myChart = document.getElementById("right_2");
            this.charbar = echarts.init(myChart);

            this.charbar.clear();
            this.charbar.setOption(option);
            var that =this;
            // 随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                that.charbar.resize();
            });
        },
    },
};
</script>
<style scoped src="@/assets/css/index3.css">

</style>